import { render, staticRenderFns } from "./AccountMyNotesAddNote.vue?vue&type=template&id=49d5ed5d&"
import script from "./AccountMyNotesAddNote.vue?vue&type=script&lang=js&"
export * from "./AccountMyNotesAddNote.vue?vue&type=script&lang=js&"
import style0 from "./AccountMyNotesAddNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports